import { ILoadingSkeletonBaseStylesProps } from "shared/components/molecules/LoadingSkeleton/atoms/styles";

import { LoadingSkeletonTextContainer } from "./styles";

export const LoadingSkeletonText = (
  props: Pick<ILoadingSkeletonBaseStylesProps, "width">,
) => {
  return <LoadingSkeletonTextContainer {...props} />;
};
